import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// WorkerLoginPage now redirects to unified login
export default function WorkerLoginPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear any old tokens and redirect to unified login
    localStorage.removeItem('portal_token');
    localStorage.removeItem('portal_user');
    localStorage.removeItem('worker_token');
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--ios-bg-gradient)' }}>
      <div style={{ color: 'var(--ios-text-secondary)' }} className="text-center">
        <p>Redirigiendo al login...</p>
      </div>
    </div>
  );
}
